import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import fnc from '../mymod/commFunction';
import './FindModals.scss';

const DeleteAccountModal = ({ onClose }) => {
  const [userId, setUserId] = useState('');
  const [pw, setPw] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [onClose]);

  function handleSubmit(e) {
    e.preventDefault();
    if (!userId.trim()) { alert('아이디를 입력해주세요.'); return; }
    if (!pw) { alert('비밀번호를 입력해주세요.'); return; }
    if (!window.confirm(`정말로 계정 "${userId}"을(를) 삭제하시겠습니까?\n\n삭제 후에는 복구할 수 없습니다.`)) return;

    setSubmitting(true);
    fnc.sendAxios('/findIdRoutes/deleteAccount', { id: userId.trim(), pw }, (res) => {
      setSubmitting(false);
      if (res.error) { alert(res.message || '계정 삭제 실패'); return; }
      setDone(true);
    });
  }

  return createPortal(
    <div className='find-modal-overlay'>
      <div className='find-modal'>
        <div className='modal-header'>
          <h3>계정 삭제</h3>
          <button className='btn-close' type='button' onClick={onClose}>✕</button>
        </div>

        <div className='modal-body'>
          {!done ? (
            <form onSubmit={handleSubmit}>
              <div className='delete-warning'>
                ⚠️ 계정을 삭제하면 모든 데이터가 영구적으로 삭제되며 복구할 수 없습니다.<br />
                계속하려면 아이디와 비밀번호를 입력해주세요.
              </div>

              <div className='field-block'>
                <label>*아이디</label>
                <div className='field-row'>
                  <input
                    type='text'
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    placeholder='가입한 아이디'
                  />
                </div>
              </div>

              <div className='field-block'>
                <label>*비밀번호</label>
                <div className='field-row'>
                  <input
                    type='password'
                    value={pw}
                    onChange={(e) => setPw(e.target.value)}
                    placeholder='비밀번호 입력'
                  />
                </div>
              </div>

              <div className='modal-footer' style={{ padding: 0, border: 'none', marginTop: '0.5rem' }}>
                <button type='button' className='btn-secondary' onClick={onClose}>취소</button>
                <button type='submit' className='btn-danger' disabled={submitting}>
                  {submitting ? '처리중...' : '계정 삭제'}
                </button>
              </div>
            </form>
          ) : (
            <div className='result-panel'>
              <div className='result-icon' style={{ background: '#ffebee', color: '#e53935' }}>✓</div>
              <p className='result-label' style={{ fontWeight: 700, color: '#1a1a1a' }}>계정이 삭제되었습니다.</p>
              <p className='result-label'>이용해 주셔서 감사합니다.</p>
            </div>
          )}
        </div>

        {done && (
          <div className='modal-footer'>
            <button type='button' className='btn-secondary' onClick={onClose}>닫기</button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default DeleteAccountModal;
